import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListSpacingRegular",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, p, a) {
  return n(), d("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--list-spacing-regular"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "List Spacing Regular",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M10 8.5a.5.5 0 1 1 0 1H2a.5.5 0 0 1 0-1h8Zm0-3a.5.5 0 1 1 0 1H2a.5.5 0 0 1 0-1h8Zm0-3a.5.5 0 1 1 0 1H2a.5.5 0 1 1 0-1h8Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const S = /* @__PURE__ */ o(c, [["render", u]]);
export {
  S as default
};
//# sourceMappingURL=list-spacing-regular.js.map
